<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <ComponentForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ComponentForm from '@/components/settings/stock-registers/component/ComponentForm'

export default {
  name: 'Components',
  components: {
    PageTitle,
    PageRowWrapper,
    ComponentForm
  }
}
</script>
